import React, { useState, useEffect } from "react";
import { Input, Form, Col, Row, Button, Select, DatePicker, InputNumber } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "../Filters/Helper";
import CurrencyInput from "react-currency-input";
import Cleave from "cleave.js/react";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 12,
    },
  },
};

const CreditCardTransactionAddForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [creditCardType, setCreditCardType] = useState("");
  const [form] = Form.useForm();
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });

  const [installmentType, setInstallmentType] = useState(0);

  const handleInstallmentTypeChange = (value) => {
    setInstallmentType(value);
  };

  const [tenantAccountSelect, setTenantAccountSelect] = useState({
    data: [],
    loading: true,
  });
  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: true,
  });

  const [SalesmanCode, setSalesmanCode] = useState({
    data: [],
    loading: true,
  });

  const [posTransactionCheck, setPosTransactionCheck] = useState({
    message: "",
    loading: false,
    inputDisabled: false
  });

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
    getAccounts();
    getCurrencies();
    getSalesmanCode();

  }, [props.data]);

  useEffect(() => { }, []);

  const onSuccess = () => {
    form.resetFields();
    if (props.onSuccess) props.onSuccess();
  };

  const onFinish = (values) => {
    if (values.transactionProcessType === 0) {
      values.transactionProcessType = null;
    }

    RequestHandler.post(`/CreditCardTransaction`, values).then((response) => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      }
    });
  };

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Firm?$select=id,firmBranchNumber,name,isActive&$filter=isActive eq true and ${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({
          data: res.value.filter((x) => x.isActive),
          loading: false,
        });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const getAccounts = () => {
    setTenantAccountSelect({
      ...tenantAccountSelect,
      loading: true,
    });
    let filter = 'isManualAccount eq true'
    if (props.isUsePosTransactionCheck)
      filter += '  and bankId ne 999'
    RequestHandler.get(`/TenantAccount?$filter=${filter}`).then(
      (response) => {
        setTenantAccountSelect({
          data: response.value,
          loading: false,
        });
      }
    );
  };

  const getSalesmanCode = () => {
    setSalesmanCode({
      ...SalesmanCode,
      loading: true,
    });
    RequestHandler.get(`/ErpLogo/GetSalesmanCodes`, [], false, {
      rawResponse: true,
    }).then((response) => {
      if (response != "") {
        setSalesmanCode({
          data: response,
          loading: false,
        });
      } else {
        setSalesmanCode({
          data: [],
          loading: false,
        });
      }
    });
  };

  const getCurrencies = () => {
    setCurrencySelect({
      data: [],
      loading: true,
    });
    RequestHandler.get(`/Currency?$select=id,code`).then((response) => {
      setCurrencySelect({
        data: response.value,
        loading: false,
      });
      form.setFieldsValue({
        ...form.getFieldValue(),
        currencyId: 1,
        installmentType: 0,
      });
    });
  };

  const onChangeTenantAccount = (value, option) => {
    let bank = props.posBankInfo.filter(x=> x.bankId == option.bankId);
    if(bank.length > 0) {
      form.setFieldsValue({
        ...form.getFieldValue(),
        posBankId: option.bankId
      });
    }
    else {
      form.resetFields(["posBankId"]);
    }

  }

  const checkPosTransaction = () => {

    var formValue = form.getFieldsValue(["posBankId", "authCode", "transactionDate"]);

    if (formValue.posBankId && formValue.authCode && formValue.transactionDate) {
      setPosTransactionCheck({
        loading: true
      });

      RequestHandler.get(
        `/PosTransaction?$count=true&$filter=posBankId eq ${formValue.posBankId} and provisionNumber eq '${formValue.authCode}' and ${odata.dateCompare("operationDate", "eq", formValue.transactionDate)}`
      ).then((response) => {

        if (response.value.length > 0) {

          var result = response.value[0];
          if(result.isSalesmanProcessed){
            setPosTransactionCheck({
              message: "Bu pos hareketi, daha önce kayıt edilmiştir. Lütfen tekrar kontrol ediniz",
              loading: false,
              inputDisabled: false
            })
            return;
          }
          var amount = response.value.reduce((accumulator, object) => {
            return accumulator + object.amount;
          }, 0);
          var currency = currencySelect.data.find(x=> x.code == result.currency);
          setInstallmentType(result.installmentCount > 1 ? 1 : 0)
          form.setFieldsValue({ "amount": amount, "valueDate": result.valueDate, "posTransactionId":result.id, "currencyId": currency.id, "cardNumber": result.cardNumber, "installmentCount": result.installmentCount, "installmentType": result.installmentCount > 1 ? 1 : 0 })
          setPosTransactionCheck({
            loading: false,
            inputDisabled: true
          });
        }
        else {
          setPosTransactionCheck({
            message: "Veri bulunamadı.",
            loading: false,
            inputDisabled: false
          })
        }

      });
    }


  }

  const baseForm = () => {
    return <Row>
      <Col span={24}>
        <Form.Item
          label="Kasa Hesabı"
          name="tenantAccountId"
          rules={[{ required: true, message: "Lütfen Kasa Hesabı seçiniz." }]}
        >
          <Select
            allowClear
            showSearch
            placeholder="Seçiniz"
            style={{ width: "100%" }}
            dropdownStyle={{ minWidth: "30%" }}
            filterOption={(input, option) =>
              option.props.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
            loading={tenantAccountSelect.loading}
            onChange={onChangeTenantAccount}
          >
            {tenantAccountSelect.data.map(
              ({
                id,
                name,
                currencyId,
                currency,
                bankName,
                accountNumber,
                iban,
                bankId
              }) => (
                <Select.Option
                  key={id}
                  value={id}
                  name={name}
                  currencyId={currencyId}
                  bankName={bankName}
                  accountNumber={accountNumber}
                  iban={iban}
                  bankId={bankId}
                >
                  {name
                    ? `${name} (${currency})`
                    : ` ${bankName} (${accountNumber ? accountNumber : iban
                    }) (${currency})`}
                </Select.Option>
              )
            )}
          </Select>
        </Form.Item>

        <Form.Item label={"Cari Adı/ Ünvanı"} name="firmId">
          <Select
            allowClear
            showSearch
            placeholder="En az 2 harf giriniz.."
            onSearch={onFirmSearch}
            style={{ width: "100%" }}
            dropdownStyle={{ minWidth: "30%" }}
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
              option.code
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
            loading={firmSelect.loading}
          >
            {firmSelect.data.map((item) => (
              <Select.Option
                key={item.id}
                value={item.id}
                code={item.firmBranchNumber}
              >
                {item.name + " (" + item.firmBranchNumber + ")"}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="valueDate" hidden></Form.Item>
        <Form.Item
          name="currencyId"
          label="Para Birimi"
          rules={[{ required: true, message: "Lütfen Para Birimi seçiniz." }]}
        >
          <Select
            defaultValue={1}
            allowClear
            showSearch
            placeholder="Seçiniz"
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
            loading={currencySelect.loading}
            defaultActiveFirstOption
          >
            {currencySelect.data.map(({ id, code }) => (
              <Select.Option key={id} value={id}>
                {code}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="posTransactionId" hidden></Form.Item>
        <Form.Item
          label="Tutar"
          name="amount"
          rules={[{ required: true, message: "Lütfen Tutar giriniz." }]}
        >
          <CurrencyInput
            style={{ width: "100%" }}
            className="ant-input"
            decimalSeparator=","
            thousandSeparator="."
            onChange={(value, name) => {
              form.setFieldsValue({
                amount: name,
              });
            }}
          />
        </Form.Item>

        <Form.Item
          label="Tarih"
          name="transactionDate"
          rules={[{ required: true, message: "Lütfen Tarih seçiniz." }]}
        >
          <DatePicker
            format="DD.MM.YYYY"
            placeholder="Tarih Seçiniz"
            style={{ width: "100%" }}
          />
        </Form.Item>

        <Form.Item label="Kart Numarası" name="cardNumber">
          <Input></Input>
        </Form.Item>

        <Form.Item label="Onay Kodu" name="authCode">
          <Input />
        </Form.Item>

        <Form.Item
          label="Taksit Seçimi"
          name="installmentType"
          rules={[
            { required: true, message: "Lütfen Taksit Seçimi yapınız." },
          ]}
        >
          <Select defaultValue={0} allowClear showSearch onChange={handleInstallmentTypeChange}>
            <Select.Option key={0} value={0}>
              Tek Çekim
            </Select.Option>
            <Select.Option key={1} value={1}>
              Taksitli İşlem
            </Select.Option>
          </Select>
        </Form.Item>
        {installmentType === 1 && (
          <Form.Item label="Taksit Sayısı" name="installmentCount" rules={[{ type: 'number', required: true, min: 2, message: 'Taksit Sayısı en az 2 olmalıdır' }]}>
            <InputNumber min={2} />
          </Form.Item>
        )}
        <Form.Item label="Satış Elemanı" name="SalesmanCode">
          <Select
            allowClear
            showSearch
            placeholder="Satış Elemanı seçiniz"
            optionFilterProp="children"
            // onChange={onChangeSalesmanCode}
            filterOption={(input, option) =>
              option.props.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
          >
            {SalesmanCode.data.length > 0 &&
              SalesmanCode.data.map((item) => (
                <Select.Option key={item.KOD} value={item.ACIKLAMASI}>
                  {item.ACIKLAMASI}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>
        <Form.Item label="Açıklama" name="description">
          <Input.TextArea rows={4} />
        </Form.Item>

        <Row justify="space-between">
          <Col></Col>
          <Col>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              htmlType="submit"
              onClick={() => setLoading(true)}
              loading={loading}
            >
              Ekle
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>;
  }

  const formWithPosTrahsactionCheck = () => {
    return <Row>
      <Col span={24}>
        <Form.Item
          label="Kasa Hesabı"
          name="tenantAccountId"
          rules={[{ required: true, message: "Lütfen Kasa Hesabı seçiniz." }]}
        >
          <Select
            allowClear
            showSearch
            placeholder="Seçiniz"
            style={{ width: "100%" }}
            dropdownStyle={{ minWidth: "30%" }}
            filterOption={(input, option) =>
              option.props.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
            loading={tenantAccountSelect.loading}
            onChange={onChangeTenantAccount}
          >
            {tenantAccountSelect.data.map(
              ({
                id,
                name,
                currencyId,
                currency,
                bankName,
                accountNumber,
                iban,
                bankId
              }) => (
                <Select.Option
                  key={id}
                  value={id}
                  name={name}
                  currencyId={currencyId}
                  bankName={bankName}
                  accountNumber={accountNumber}
                  iban={iban}
                  bankId={bankId}
                >
                  {name
                    ? `${name} (${currency})`
                    : ` ${bankName} (${accountNumber ? accountNumber : iban
                    }) (${currency})`}
                </Select.Option>
              )
            )}
          </Select>
        </Form.Item>

        <Form.Item label={"Cari Adı/ Ünvanı"} name="firmId">
          <Select
            allowClear
            showSearch
            placeholder="En az 2 harf giriniz.."
            onSearch={onFirmSearch}
            style={{ width: "100%" }}
            dropdownStyle={{ minWidth: "30%" }}
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
              option.code
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
            loading={firmSelect.loading}
          >
            {firmSelect.data.map((item) => (
              <Select.Option
                key={item.id}
                value={item.id}
                code={item.firmBranchNumber}
              >
                {item.name + " (" + item.firmBranchNumber + ")"}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Banka" name="posBankId">
          <Select
            allowClear
            showSearch
            placeholder="Seçiniz"
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
            loading={currencySelect.loading}
            defaultActiveFirstOption
          >
            {props.posBankInfo.map(({ bankId, bankName }) => (
              <Select.Option key={bankId} value={bankId}>
                {bankName}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Onay Kodu" name="authCode">
          <Input />
        </Form.Item>

        <Form.Item
          label="Tarih"
          name="transactionDate"
          rules={[{ required: true, message: "Lütfen Tarih seçiniz." }]}
        >
          <DatePicker
            format="DD.MM.YYYY"
            placeholder="Tarih Seçiniz"
            style={{ width: "100%" }}
          />
        </Form.Item>

        <Row justify="space-between">
          <Col></Col>
          <Col></Col>
          <Col>
            {posTransactionCheck.message}
          </Col>
          <Col>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              htmlType="button"
              onClick={() => checkPosTransaction()}
              loading={posTransactionCheck.loading}
            >
              Hareket Sorgula
            </Button>
          </Col>
        </Row>

        <Form.Item name="posTransactionId" hidden></Form.Item>
        <Form.Item
          label="Tutar"
          name="amount"
          rules={[{ required: true, message: "Lütfen Tutar giriniz." }]}
        >
          <CurrencyInput
            style={{ width: "100%" }}
            className="ant-input"
            decimalSeparator=","
            thousandSeparator="."
            onChange={(value, name) => {
              form.setFieldsValue({
                amount: name,
              });
            }}
            disabled={true}
          />
        </Form.Item>


        <Form.Item name="valueDate" hidden></Form.Item>
        <Form.Item
          name="currencyId"
          label="Para Birimi"
          rules={[{ required: true, message: "Lütfen Para Birimi seçiniz." }]}
        >
          <Select
            defaultValue={1}
            allowClear
            showSearch
            placeholder="Seçiniz"
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
            loading={currencySelect.loading}
            defaultActiveFirstOption
            disabled={true}
          >
            {currencySelect.data.map(({ id, code }) => (
              <Select.Option key={id} value={id}>
                {code}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Kart Numarası" name="cardNumber">
          <Input disabled={true}></Input>
        </Form.Item>


        <Form.Item
          label="Taksit Seçimi"
          name="installmentType"
          rules={[
            { required: true, message: "Lütfen Taksit Seçimi yapınız." },
          ]}
        >
          <Select defaultValue={0} allowClear showSearch disabled={true} onChange={handleInstallmentTypeChange}>
            <Select.Option key={0} value={0}>
              Tek Çekim
            </Select.Option>
            <Select.Option key={1} value={1}>
              Taksitli İşlem
            </Select.Option>
          </Select>
        </Form.Item>
        {installmentType === 1 && (
          <Form.Item label="Taksit Sayısı" name="installmentCount" rules={[{ type: 'number', required: true, min: 2, message: 'Taksit Sayısı en az 2 olmalıdır' }]}>
            <InputNumber min={2} disabled={true} />
          </Form.Item>
        )}
        <Form.Item label="Satış Elemanı" name="SalesmanCode">
          <Select
            allowClear
            showSearch
            placeholder="Satış Elemanı seçiniz"
            optionFilterProp="children"
            // onChange={onChangeSalesmanCode}
            filterOption={(input, option) =>
              option.props.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
          >
            {SalesmanCode.data.length > 0 &&
              SalesmanCode.data.map((item) => (
                <Select.Option key={item.KOD} value={item.ACIKLAMASI}>
                  {item.ACIKLAMASI}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>

        <Form.Item label="Açıklama" name="description">
          <Input.TextArea rows={4} />
        </Form.Item>

        <Row justify="space-between">
          <Col></Col>
          <Col>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              htmlType="submit"
              onClick={() => setLoading(true)}
              loading={loading}
            >
              Ekle
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>;
  }
  return (
    <Form
      {...formItemLayout}
      form={form}
      name="CreditCardTransactionAdd"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      {
        props.isUsePosTransactionCheck ? formWithPosTrahsactionCheck() : baseForm()
      }

    </Form>
  );
};
export default CreditCardTransactionAddForm;
